import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import QrCodeWithLogo from "qr-code-with-logo";
import {HttpClient} from "@angular/common/http";
import Echo from "laravel-echo-socketcluster";

@Component({
  selector: 'qr-code-view',
  template: `
    <canvas class="qrcode" [style.opacity]="timedOut ? 0.4:1" #canvas></canvas>
    <div class="overlay" [style.display]="timedOut ? 'block':'none'">
      <div class="circle">
        <img (click)="startGeneratingQrCodes()" class="button" src="data:image/png;base64,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">
      </div>
    </div>
  `,
  styleUrls: ['./qr-code-view.component.scss']
})
export class QrCodeViewComponent implements OnInit, AfterViewInit  {

  ngOnInit() {
  }

  @ViewChild("canvas", {static: false}) myCanvas;
  // @ViewChild("qrimage", {static: false}) myImage;
  @Input() size: any = 200;
  @Input() generateCodeEndPoint: any = "https://api.alfapay.digital/v1/account/user/qrcode_login";
  @Input() authorizationHostname: any = "api.alfapay.digital";
  @Input() refresh: any = 30;
  @Input() limit: any = 5;
  @Input("logo") qrcodeLogo: any = 'https://alfapay.digital/favicon.ico';
  @Output('onSuccess') onSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output('onFailure') onFailure: EventEmitter<any> = new EventEmitter<any>();

  private echo: any;
  private generateCount: number = 0;
  public timedOut: boolean = false;

  private secure = window.location.protocol == "https:";
  private socketClusterOptions = {
    hostname: 'alfapay.digital',
    // secure: this.secure,
    secure: false,
    port: this.secure ? 8443 : 8001,
    rejectUnauthorized: false, // Only necessary during debug if using a self-signed certificate
  };
  private showCodeInterval: any;

  constructor(private http: HttpClient) { }

  connectChannel(): void {
    if (this.echo) {
      return;
    }
    this.echo = new Echo({
      broadcaster: 'socketcluster',
      key: 'your-pusher-key',
      auth: {
        headers: {
          // Authorization: `Bearer ${this.user.currentUserValue.jwt_token}`
        },
        hostname: this.authorizationHostname,
        secure: true
      },
      socketcluster: this.socketClusterOptions
    });

  }


  disconnetChannel(): void {
    if (this.echo) {
      this.echo.disconnect();
    }
    this.echo = null;
  }

  showQrCode(){
    // obtain a code from the server
    this.http.get(this.generateCodeEndPoint,
      {headers: {'Content-Type': 'application/json', 'X-Socket-ID':this.echo.socketId()}})
      .subscribe((result: {qr_code: string, status: boolean}) => {
        console.log(result);
        this.generateCount++;
        this.generateFreshQrCode(result.qr_code, true);
        //this.generateFreshQrCode("test", true);
      }, (error) => {
        console.log('error ', error);
        this.onFailure.emit();
      });
  }

  ngAfterViewInit(){
    this.connectChannel();
    setTimeout(() => {
      this.startGeneratingQrCodes();
    }, 2000);
  }

  startGeneratingQrCodes():void {
    this.timedOut = false;
    this.generateCount = 0;
    try{
      clearInterval(this.showCodeInterval);
    }catch (e) {
      console.error(e);
    }
    this.showQrCode();
    this.showCodeInterval = setInterval(() => {
      if(this.generateCount >= parseInt(this.limit)){
        console.log("stopping temporarily");
        clearInterval(this.showCodeInterval);
        this.reachedTimeout();
        return;
      }
      this.showQrCode();
    }, this.refresh*1000);
  }

  reachedTimeout(){
    this.timedOut = true;
  }

  public generateFreshQrCode(code_to_encode, connect_to_channel){
    QrCodeWithLogo.toCanvas({
      canvas: this.myCanvas.nativeElement,
      content: code_to_encode,
      width: this.size,
      logo: {
        src: this.qrcodeLogo,
      }
    });

    /*QrCodeWithLogo.toImage({
      image: this.myImage.nativeElement,
      content: code_to_encode,
      width: this.size
    });
    */

    if(connect_to_channel){
      console.log('subscribing to channel');
      // connect to the channel and wait for response
      this.echo.channel(`qrauth.${code_to_encode}`)
        .listen('QrLoginPassed', (e: {jwt_token: string, user: any}) => {
          console.log('user authentication passed');
          console.log(e);
          this.disconnetChannel();
          clearInterval(this.showCodeInterval);
          this.onSuccess.emit(e);
        })
        .listen('QrLoginFailed', (e) => {
          console.error('qr auth failed');
          this.onFailure.emit();
        })
      ;
    }

  }

}
